import React from "react";

import Nav from "./Nav";

export default () => {
  return (
    <div>
      <Nav />
      <section className="section" />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Home/index.js